// @flow

type Action =
  | {
      type: 'FIREBASE_USER_LOGIN_SUCCESS',
      user: FirebaseUser,
      isNew: boolean,
    }
  | {
      type: 'FETCH_AVA_SESSION_SUCCESS',
      photoUrl: string,
    }
  | {
      type: 'FIREBASE_USER_LOGOUT',
    }
  | {
      type: 'UPDATE_SCRIBE_REMAINING_TIME',
      scribeRemainingTimeMs: number,
    }
  | {
      type: 'UPDATE_PAID_ASR_CREDIT_TIME',
      paidASRCreditTime: number,
    }
  | {
      type: 'DECREASE_PAID_ASR_CREDIT_TIME',
    }
  | {
      type: 'DECREASE_SCRIBE_REMAINING_TIME',
    };

export type State = {
  user?: FirebaseUser,
  isNew?: boolean,
  scribeRemainingTime: number,
  paidASRCreditTime: number,
};

const initialState = {
  scribeRemainingTime: 0,
  paidASRCreditTime: 0,
};

export default function scribeFirebase(state: State = initialState, action: Action): State {
  switch (action.type) {
    case 'FIREBASE_USER_LOGIN_SUCCESS':
      return { ...state, user: action.user, isNew: action.isNew };

    case 'FIREBASE_USER_LOGOUT':
      return { ...state, user: undefined };
    case 'FETCH_AVA_SESSION_SUCCESS':
      if (!action.photoUrl) return { ...state };
      return {
        ...state,
        user: {
          ...state.user,
          photoURL: action.photoUrl,
        },
        isNew: false,
      };
    case 'UPDATE_SCRIBE_REMAINING_TIME':
      return { ...state, scribeRemainingTime: action.scribeRemainingTimeMs };
    case 'UPDATE_PAID_ASR_CREDIT_TIME':
      return { ...state, paidASRCreditTime: action.paidASRCreditTime };
    case 'DECREASE_PAID_ASR_CREDIT_TIME':
      return { ...state, paidASRCreditTime: state.paidASRCreditTime - 1000 };
    case 'DECREASE_SCRIBE_REMAINING_TIME':
      return { ...state, scribeRemainingTime: state.scribeRemainingTime - 1000 };
    default:
      // eslint-disable-next-line no-unused-expressions
      (action: empty);
      return state;
  }
}
